const r = Symbol("CustomSelectList");
var i = /* @__PURE__ */ ((t) => (t.large = "large", t.medium = "medium", t.small = "small", t.lg = "lg", t.md = "md", t.sm = "sm", t))(i || {}), n = /* @__PURE__ */ ((t) => (t.outline = "outline", t["outline-light"] = "outline-light", t.fill = "fill", t["fill-light"] = "fill-light", t))(n || {});
const a = (t) => {
  switch (t) {
    case "lg":
    case "large":
      return "input-lg";
    case "md":
    case "medium":
      return "input-md";
    case "sm":
    case "small":
      return "input-sm";
    default:
      return "input-md";
  }
}, c = (t) => {
  switch (t) {
    case "outline":
      return "input-field-outline";
    case "outline-light":
      return "input-field-outline-light";
    case "fill-light":
      return "input-field-light";
    case "fill":
    default:
      return "";
  }
}, f = (t) => {
  const e = "input-field", l = c(t);
  return `${e} ${l}`;
}, u = (t) => {
  const e = "input input-primary", l = t.disabled ? "input-disabled" : "", s = t.invalid ? "input-invalid" : "";
  return `${e} ${l} ${s}`;
}, o = (t) => {
  const e = [];
  return t.native || e.push("selection-colors"), e.join(" ");
}, d = (t) => {
  const e = ["input-icon"];
  return !t.native && (t.variant === "fill" || t.variant === "fill-light") && e.push("input-icon-fill"), (t.variant === "outline" || t.variant === "outline-light") && e.push("outline-leading-icon"), e.join(" ");
}, m = (t) => {
  const e = ["select-custom-icon"];
  return (t.variant === "fill" || t.variant === "fill-light") && e.push("select-custom-icon-fill"), e.join(" ");
}, g = (t, e) => {
  const l = ["select-custom"];
  return t.disabled && l.push("input-field-disabled"), e || l.push("select-closed"), l.join(" ");
}, C = (t, e, l) => {
  const s = ["select-custom-selected-label"];
  return (t.variant === "fill" || t.variant === "fill-light") && s.push("select-custom-selected-label-bottom"), e && s.push("select-custom-selected-label-indent"), l && s.push("select-custom-selected-label-cover"), s.join(" ");
}, h = (t, e, l) => {
  const s = ["input-label"];
  return e && s.push("input-label-indent"), (t.variant === "outline" || t.variant === "outline-light") && !t.native && s.push("input-field-outline-select"), (t.variant === "fill" || t.variant === "fill-light") && (l && Array.isArray(l) && l.length === 0 || !l) && t.multiselect && s.push("input-label-of-pristine-multiselect"), s.join(" ");
}, v = (t, e) => {
  const l = ["select-icon"];
  return e && l.push("select-custom-flipped-icon"), (t.variant === "outline" || t.variant === "outline-light") && l.push("select-icon-outline"), l.join(" ");
}, b = (t) => {
  const e = u(t), l = a(t.size), s = o(t);
  return `${e} ${l} ${s}`;
};
export {
  r as CustomSelectListSymbol,
  i as InputSize,
  n as InputVariant,
  v as getCustomSelectChevronStyleClasses,
  g as getCustomSelectDropdownActivatorStyleClasses,
  d as getCustomSelectIconStyleClasses,
  o as getCustomSelectLabelStyleClasses,
  h as getCustomSelectLabelTextStyleClasses,
  m as getCustomSelectOptionIconStyleClasses,
  C as getCustomSelectedLabelStyleClasses,
  f as getInputFieldStyleClasses,
  b as getInputLabelStyleClasses,
  u as getTextareaLabelStyleClasses
};
